import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore/lite';
import { connectStorageEmulator, getStorage } from 'firebase/storage';

const app = initializeApp({
  apiKey: 'AIzaSyBerfFUcFcw24-eZFlhIMSfIR7vtcOpc-s',
  authDomain: 'fordonsdalen-lms.firebaseapp.com',
  projectId: 'fordonsdalen-lms',
  storageBucket: 'fordonsdalen-lms.appspot.com',
  messagingSenderId: '870918140403',
  appId: '1:870918140403:web:4497adaf098d30c9be2286',
  measurementId: 'G-BD3WKTD4C2',
});

export default app;
export const firestore = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

if (window.location.hostname.includes('localhost')) {
  connectFirestoreEmulator(firestore, 'localhost', 8080);
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectStorageEmulator(storage, 'localhost', 9199);
}
